import {Section, Title, CheckboxControl, GradeSectionBox} from './index.styled';
import {FlexBox} from '@esgi/ui/layout';
import {GradeIndicator} from './grade-indicator';
import {
	GradeScale,
} from '@esgi/contracts/esgi/types/esgi.reports/endpoints/esgi.apigateway/student-progress-report/models/grade-scale';
import {getThemeColor} from '@esgi/ui';

interface Props {
	disabled?: boolean;
	onChange: (value: boolean) => void;
	value: boolean;
	gradeScales: GradeScale[];
}

export function GradeLevelControl({disabled, onChange, value, gradeScales}: Props) {

	return (
		<Section>
			<Title size='small' font='mono' color='neutral64'>Grades</Title>
			<CheckboxControl checked={value} onCheckedChange={(value) => onChange(!!value)} label='Include Grades' disabled={disabled}/>
			{gradeScales?.length > 0 && <GradeSectionBox>
				<FlexBox justify='center' align='center'>
					{gradeScales[0].gradeValues.map((item) => <GradeIndicator key={`${item.description}_${item.name}`} gradeValue={item.name} indicatorColor={!value ? getThemeColor('neutral64') : item.color} indicatortextColor='neutral99' />)}
				</FlexBox>
			</GradeSectionBox>}
		</Section>
	);
}
